// extracted by mini-css-extract-plugin
export default {"hideOnSmall":"GlobalCreateMenu-module__hideOnSmall--iImkl","actionMenuButton":"GlobalCreateMenu-module__actionMenuButton--fOjh3"};